import { Bean, CircleDot, Disc, GlassWater, Ship, Target } from 'lucide-react';
import type { GameKind } from '@awwyeah/shared';

/**
 * One glyph per kind — a card should say what it is before you read it. Shared by the
 * household games list and the guest lounge (friend of the family).
 */
export function KindIcon({ kind, size = 14 }: { kind: GameKind; size?: number }): JSX.Element {
  const Icon =
    kind === 'battleship'
      ? Ship
      : kind === 'checkers'
        ? Disc
        : kind === 'pool'
          ? Target
          : kind === 'beerpong'
            ? GlassWater
            : kind === 'mancala'
              ? Bean
              : CircleDot;
  return <Icon size={size} aria-hidden="true" data-testid="game-kind-icon" data-kind={kind} />;
}
